document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
        const tooltips = document.querySelectorAll('.tooltip-container');
        const tooltipContents = Array.from(tooltips).map(tooltip => tooltip.querySelector('.tooltip-content'));

        // Close tooltip when close button is clicked
        tooltips.forEach(tooltip => {
            const closeButton = tooltip.querySelector('.close-button');
            const tooltipContent = tooltip.querySelector('.tooltip-content');
            if (closeButton) {
                closeButton.addEventListener('click', function (e) {
                    tooltipContent.style.display = 'none';
                });
            }
        });

        // Show tooltip when info icon is hovered
        tooltips.forEach(tooltip => {
            const tooltipContent = tooltip.querySelector('.tooltip-content');
            const infoIcon = tooltip.querySelector('.info-icon');
            if (infoIcon) {
                infoIcon.addEventListener('click', function (e) {

                    // close all tooltips
                    tooltipContents.forEach(content => {
                        content.style.display = 'none';
                    });

                    // open tooltip
                    tooltipContent.style.display = 'block';
                });
            }
        });
        
    }
});